import { useContext, useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SessionContext from '../library/Core/SessionContext';
import { GlobalContext } from '../library/Core/GlobalContext';
import MenuBuilderServiceAlumni from '../services/menu-builder.service';
import { getInstituteFlags, getLoginMode, getStudyPreferencePath, isSchoolAdmin } from '../library/Core/SmartFunctions';
import { useCapabilities } from '../common/hooks/useCan';

const MenuBuilder = () => {
    const { sessionState } = useContext(SessionContext);
    // Role capabilities: a menu entry may carry `capability: 'x.y.z'`; it is hidden unless the user has it (always shown when REACT_APP_CAPABILITY_UI is off)
    const { can: canCapability } = useCapabilities();
    const { globalState } = useContext(GlobalContext);
    const user = JSON.parse(sessionStorage.getItem('user'))
    const recruiterEnabled=user?.recruiterEnabled
    const { userTypeCode, userStatusCode, pursuingEducationLevelCode  } = sessionState;

    let myBusinessDirSummary = sessionState?.myBusinessDirSummary;

    // Uses INSTITUTE_DOMAIN flexCol (commitment_paths) from the domain data already loaded
    // in global state, instead of hitting the /institute/:id endpoint. Only relevant for
    // INSTITUTE_ADMIN logins.
    const [domainExpertEnabled, setDomainExpertEnabled] = useState(false);
    const [mentorshipHeader, setMentorshipHeader] = useState(false);

    useEffect(() => {
        const instituteId = sessionState?.primaryInstitute || user?.primaryInstitute || user?.instituteId;
        if (!instituteId) return;
        const { domainExpert, mentorshipHeader: mentorshipEnabled } = getInstituteFlags(
            { domain: globalState?.domain },
            [instituteId]
        );
        if (isSchoolAdmin()) {
            setDomainExpertEnabled(domainExpert);
        }
        setMentorshipHeader(mentorshipEnabled);
    }, [sessionState?.userTypeCode, sessionState?.primaryInstitute, globalState?.domain]);

    const defaultProductMenu = { pbp: true, cagp: true, ps: true };
    // const StudenttestMenu = JSON.parse(sessionStorage.getItem('product-menu-test') || '{}');
    const StudenttestMenu = JSON.parse(localStorage.getItem('product-menu-test') || '{}');
    const mergedMenu = { ...defaultProductMenu, ...StudenttestMenu };

    const userId = sessionState.id;
    const isCounsellor =sessionState?.isCounsellor
    const [isModalOpen, setIsModalOpen] = useState(false); // State to track modal visibility
    const [openMenu, setOpenMenu] = useState('');

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [careerDeepDiveClass, setCareerDeepDiveClass] = useState("gray-effect");
    const [careerDeepDivePath, setCareerDeepDivePath] = useState("#");

    // if myBusinessDirSummary is not available in sessionState, try to get it from sessionStorage (in case it was set there during institute selection)
    if (!myBusinessDirSummary && typeof sessionStorage !== 'undefined') {
        try {
            const businessDirSummary = sessionStorage.getItem('business-directory-summary');
            if (businessDirSummary) {
                myBusinessDirSummary = JSON.parse(businessDirSummary);
            }
        } catch (e) {
            console.warn('Invalid sessionStorage data for business-directory-summary', e);
        }
    }
        
    // Snapshot-backed dashboard: always listed for institute/school admin.
    // Do not probe the API here — MenuBuilder mounts on every management page.
    const primaryInstitute = sessionState?.primaryInstitute;
    const hasProfileAnalytics = userTypeCode === 'INSTITUTE_ADMIN' || userTypeCode === 'SCHOOL_ADMIN';

    useEffect(() => {
        if (StudenttestMenu && Object.keys(StudenttestMenu).length > 0 
            && StudenttestMenu.career_deep_dive === true) {
            setCareerDeepDiveClass("")
            setCareerDeepDivePath('/careers');
        } else {
            setCareerDeepDiveClass("gray-effect")
            setCareerDeepDivePath('#');
        }

        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty dependency array ensures this effect runs only once

    // TODO: Move the menu config to Database for better maintenance;

    let businessDashboardLink = []

    if(myBusinessDirSummary?.hasListing == 1 && userTypeCode === 'ALUMNI'){
        businessDashboardLink.push({ id: 'my-business-listing', label: 'My Business Listing', path: '/alumni/inquiry-management', class: '' })
        businessDashboardLink.push( { id: 'service-provider-dashboard', label: 'Service Provider Dashboard', path: '/alumni/service-provider-dashboard', class: '' })
    }

    if(myBusinessDirSummary?.hasSentEnquiry == 1 && userTypeCode === 'ALUMNI'){
        businessDashboardLink.push({ id: 'active-inquiries', label: 'Active Inquiries', path: '/alumni/my-enquiries', class: '' })
    }

    const MyDashBoard = {
        id: 'my-dashboard',
        label: 'MY DASHBOARD',
        children: [
            { id: 'my-dashboard', label: 'Dashboard', path: '/alumni/dashboard', class: '' },
            ...businessDashboardLink,
        ],
        
    };

    const NextMove = {
        id: 'next-move',
        label: 'Next Move',
        children: [
            { id: 'profile-skills', label: 'Skill Profile', path: `/alumni/${userId}/skills`, class: '' },
            { id: 'study-preference', label: 'Study Preferences', path: getStudyPreferencePath(userId, sessionState), class: '' },
            { id: 'job-preference', label: 'Job Preferences', path: `/alumni/${userId}/job-preferences`, class: '' },
            { id: 'Achievements', label: 'Achievements', path: `/alumni/${userId}/achievements`, class: '' },
            // { id: 'top-college', label: 'Top Colleges', path: 'top-colleges' },
        ],
    };

    const Connect = {
        id: 'connect',
        label: 'CONNECT',
        children: [
            { id: 'directory', label: 'Directory', path: '/alumni/directory', class: '' },
            // { id: 'entrepreneurs', label: 'Entrepreneurs', path: '/entrepreneur/directory', class: '' },
            { id: 'business-directory', label:' Business Directory', path: '/alumni/business-directory', class: ''},
            { id: 'batch-mates', label: 'Batchmates', path: '/alumni/batch-mates-directory', class: '' },
            { id: 'juniors', label: 'Juniors', path: '/alumni/juniors-directory', class: '' },
            { id: 'Seniors', label: 'Seniors', path: '/alumni/seniors-directory', class: '' },
            { id: 'qna', label: 'QnA Board', path: '/qna-dashboard', class: '' },
            // { id: 'School', label: 'School', path: '/alumni/school-directory', class: '' },
        ],
    };

    if (sessionState?.instituteDomain == 'miles') { // Temp'ly for Facebook Review purpose
        Connect.children.push({ id: 'social-integration', label: 'Social Integration', path: '/socialmedia/social-integration', class: '' })
        Connect.children.push({ id: 'social-media-posts', label: 'Social Media Posts', path: '/socialmedia/posts', class: '' })
        
    }

    const Contribute = {
        id: 'contribute',
        label: 'CONTRIBUTE',
        children: [
            { id: 'memories', label: 'Memories', path: '/memories', class: '' },
            { id: 'guidance', label: 'Guidance Videos', path: '/guidance', class: '' },
            { id: 'job', label: 'Job & Internship', path: '/job-posting', class: '' },
            { id: 'review-profiles', label: 'Review Profile', path: '/alumni-review/peer', class: '' },
        ],
    };

    // Management
    const Manage = {
        id: 'manage',
        label: 'MANAGE',
        children: [
            { id: 'users', label: 'Users', path: '' },
            { id: 'student', label: 'Students', path: '/management/track/student-profiles', class: '' },
            { id: 'alumni', label: 'Alumni', path: '/alumni/directory', class: '' },
            ...(recruiterEnabled ? [{ id: 'recruiter', label: 'Recruiter', path: '/recruiter/directory', class: '' }] : []),
            ...(domainExpertEnabled ? [{id: 'domain-expert-directory', label: 'Domain Expert Directory', path: '/domain-expert/directory', class: ''}] : []),
            ...(mentorshipHeader ? [{ id: 'mentorship', label: 'Mentorship', path: '/management/mentorship/module-settings', class: '' }] : []),
            { id: 'entrepreneur-directory', label: 'Entrepreneur Directory', path: '/entrepreneur/directory', class: '' },
            { id: 'business-directory-report', label: 'Business Directory', path: '/support/business-directory', class: '' },
            { id: 'lead', label: 'Leads', path: '/lead/managelead', class: '' },
            { id: 'create-user', label: 'Create User', path: '/support/create-new-user', class: '' },

            { id: 'institute_data', label: 'Institute Data', path: '' },
            { id: 'listing', label: 'Programs', path: '/program/listing', class: '' },
            { id: 'qna', label: 'QnA Board', path: '/qna-dashboard', class: '' },
            { id: 'social-integration', label: 'Social Integration', path: '/socialmedia/social-integration', class: '' },
            {
                id: 'grievance_mgmt',
                label: 'Grievance Management',
                path: '/management/grievance-v2',
                class: '',
            },
        ],
    };

    const Dashboard = {
        id: 'dashboard',
        label: 'DASHBOARD',
        children: [
            // Onboarding is superseded by the Profile Analytics Dashboard once data has been
            // uploaded for any institute in this admin's group.
            ...(hasProfileAnalytics ? [] : [{ id: 'onboarding', label: 'Onboarding', path: '/management/dashboard', class: '' }]),
           // { id: 'onboarding', label: 'Onboarding', path: '/management/dashboard', class: '' },
            // { id: 'commitment-dashboard', label: 'Commitment Dashboard', path: '/management/commitment-dashboard', class: '' },
            ...(recruiterEnabled ? [{ id: 'recruiter-dashboard', label: 'Recruiter Dashboard', path: '/management/recruiter-dashboard', class: '' }] : []),
            ...(hasProfileAnalytics ? [{ id: 'profile-analytics-dashboard', label: 'Profile Analytics Dashboard', path: '/management/profile-analytics-dashboard', class: '' }] : []),
            { id: 'watchlist-dashboard', label: 'Watchlist Dashboard', path: `/management/watchlist-dashboard/${primaryInstitute}`, class: '' },
            { id: 'placement-analytics', label: 'Placement Analytics', path: '/management/placement-analytics', class: '' },
        ],
    };

    const ManagementConnect = {
        id: 'management-connect',
        label: 'ENGAGE',
        children: [
            { id: 'student', label: 'Students', path: '/student-messages', class: '' },
            { id: 'alumni', label: 'Alumni', path: '/alumni-messages', class: '' },
            { id: 'broadcast', label: 'Broadcast', path: '/broadcast', class: '' },
            { id: 'social-media-posts', label: 'Social Media Posts', path: '/socialmedia/posts', class: '' },
            { id: 'invite_to_platform', label: 'Invite to Platform', path: '/alumni-invite/peer', class: '' },
            { id: 'ask_google_review', label: 'Ask Google Review', path: '/broadcast/ask-google-review', class: '' },
            { id: 'reference', label: 'Ask for Referral', path: '/reference/manage', class: '' },
        ],
    };

    const ManagementTrackStudents = {
        id: 'management-track-students',
        label: 'STUDENTS',
        children: [
            { id: 'profiles', label: 'Profiles', path: '/management/track/student-profiles', class: '' },
            { id: 'careerPreferences', label: 'Career Preferences', path: '/management/track/student-career-preferences', class: '' },
        ],
    };

    const ManagementTrackAlumni = {
        id: 'management-track-alumni',
        label: 'ALUMNI',
        children: [
            { id: 'profiles', label: 'Profiles', path: '/management/track/alumni-profiles', class: '' },
            { id: 'educationPreferences', label: 'Education Details', path: '/management/track/alumni-education-preferences', class: '' },
            {
                id: 'engagementWithStudents',
                label: 'Engagement with Students',
                path: '/management/track/alumni-engagement-with-students',
                class: '',
            },
            // {
            //     id: 'hightlightsAndStudentsEngaggement',
            //     label: 'Hightlights and Students Engagement',
            //     path: '/management/track/alumni-highlights-with-students-engagement',
            //     class: '',
            // },
        ],
    };

    const ManagementTrack = {
        id: 'management-track',
        label: 'TRACK',
        children: [
            // { id: 'students', label: 'Students', path: '' },
            { id: 'student-profiles', label: 'Student Profiles', path: '/management/track/student-profiles' },
            { id: 'careerPreferences', label: 'Student Career Preferences', path: '/management/track/student-career-preferences' },
            // { id: 'alumni', label: 'Alumni', path: '' },
            { id: 'alumni-profiles', label: 'Alumni Profiles', path: '/management/track/alumni-profiles' },
            { id: 'educationPreferences', label: 'Alumni Education Details', path: '/management/track/alumni-education-preferences' },
            { id: 'engagementWithStudents', label: 'Engagement with Students', path: '/management/track/alumni-engagement-with-students' },
            { id: 'birthdays', label: 'Upcoming Birthdays', path: '/alumni/birthdays' },
            { id: 'activityLogReport', label: 'User Engagement', path: '/management/track/activity-log-report' },
            { id: 'custom-report-events', label: 'Event Participation', path: '/support/custom-reports/events' },
            { id: 'custom-report-rewards', label: 'Rewards & Recognitions', path: '/support/custom-reports/rewards' },
            { id: 'custom-report-markers', label: 'Ability Markers', path: '/support/custom-reports/markers' },
            // {
            //     id: 'hightlightsAndStudentsEngaggement',
            //     label: 'Hightlights and Students Engagement',
            //     path: '/management/track/alumni-highlights-with-students-engagement',
            // },
        ],
    };

    const ManagementResources = {
        id: 'management-resources',
        label: 'TOOLKIT',
        children: [
            { id: 'guidance', label: 'Guidance Videos', path: '/guidance', class: '' },
            { id: 'widget', label: 'Widget', path: '/widget/listing', class: '' },
            { id: 'Email Template', label: 'Email Template', path: '/broadcast/email-templates', class: '' },
            { id: 'Image Templates', label: 'Image Templates', path: '/image-template', class: '' },
            { id: 'Sync Profile Marker', label: 'Sync Profile Marker', path: '/sync-profile-marker', class: '' }
        ],
    };

    const ManagementMeetingsAndEvents = {
        id: 'management-meetings-events',
        label: 'MEETINGS & EVENTS',
        children: [
            { id: 'upcoming-events', label: 'Upcoming Events', path: '/events/upcoming', class: '' },
            { id: 'past-events', label: 'Past Events', path: '/events/past', class: '' },
            { id: 'job', label: 'Job & Internship', path: '/job-posting', class: '' },
        ],
    };

    // Student Menu
    const MyJourny = {
        id: 'myjourny',
        label: 'My journey',
        // children: [],
    };

    const RESEARCH = {
        id: 'research',
        label: 'RESEARCH',
        children: [
            { id: 'alumni-guidance', label: 'Alumni Guidance', path: '/guidance', class: '', target: '_blank' },
            { id: 'recommended-college', label: 'Recommended Colleges', path: '#', class: 'gray-effect' },
            { id: 'top-college', label: 'Top Colleges', path: '/top-colleges', class: '' },
            //{ id: 'top-college', label: 'Top Colleges', path: '#', class: 'gray-effect' },
            { id: 'careers', label: 'Careers', path: careerDeepDivePath, class: careerDeepDiveClass },
            { id: 'top-scholarships', label: 'Scholarships', path: '#', class: 'gray-effect' },
            { id: 'admission-tests', label: 'Admission Tests', path: '#', class: 'gray-effect' },
        ],
    };

    const StudentConnect = {
        id: 'student-connect',
        label: 'CONNECT',
        children: [
            { id: 'alumni-search', label: 'Alumni', path: '/alumni/directory', class: '' },
            // { id: 'entrepreneurs', label: 'Entrepreneurs', path: '/entrepreneur/directory', class: '' },
            { id: 'counsellor', label: 'Counsellor', path: '#', class: 'gray-effect' },
            { id: 'university', label: 'University', path: '#', class: 'gray-effect' },
            { id: 'qna', label: 'QnA Board', path: '/qna-dashboard', class: '' },
            // Mentors lives under MENTORSHIP for STUDENT (userTypeCode), not CONNECT.
            // { id: 'bas', label: 'Book a session', path: '#', class: 'gray-effect' },
        ],
    };

    const ManageAdmin = {
        id: 'manage-admin',
        label: 'Manage',
        children: [
            { id: 'institute_data', label: 'Institute Data', path: '' },
            { id: 'listing', label: 'All Institutes', path: '/institute/listing', class: '' },
            { id: 'mentorship', label: 'Mentorship', path: '/management/mentorship/module-settings', class: '' },
             { id: 'companylisting', label: 'All Companies ', path: '/company/listing', class: '' }, 
            { id: 'Event', label: 'Events', path: '/event/manageevent', class: '' },
            { id: 'qna', label: 'QnA Board', path: '/internal/qna-dashboard', class: '' },
            {
                id: 'psychometric_bas_mapping',
                label: 'Psychometric Test and BAS Mapping',
                path: '/management/psychometric-bas-mapping',
                class: '',
            },
            {
                id: 'psychometric_links',
                label: 'Psychometric Links generation',
                path: '/psychometriclink/psychometric-links',
                class: '',
            },
            {
                id: 'grievance_mgmt',
                label: 'Grievance Management',
                path: '/support/grievance-v2',
                class: '',
            },
            {
                id: 'manage-roles',
                label: 'Manage roles',
                path: '/support/roles',
                capability: 'role.capability.manage',
                class: '',
            },
            {
                id: 'manage-capabilities',
                label: 'Manage capabilities',
                path: '/support/capabilities',
                capability: 'role.capability.manage',
                class: '',
            },
            {
                id: 'role-capabilities',
                label: 'Role capabilities',
                path: '/support/role-capabilities',
                capability: 'role.capability.manage',
                class: '',
            },
            { id: 'widget', label: 'Widget', path: '/widget/listing', class: '' },
            // {
            //     id: 'all_companies',
            //     label: 'All Companies',
            //     path: '',
            //     class: '',
            // },
        ],
    };

    const ReportsAdmin = {
        id: 'reports-admin',
        label: 'Reports',
        children: [
            { id: 'all-alumni-report', label: 'All Alumni Profiles', path: '/support/all-alumni-report', class: '' },
            { id: 'profiles', label: 'All Student Profiles', path: '/support/student-profile-report', class: '' },
            { id: 'bas-profiles', label: 'All Counselling Students',             
            path: isCounsellor ? `/support/all-bas-report/${userId}` : '/support/all-bas-report', class: '' },
            { id: 'domain-data', label: 'Domain Category Report', path: '/domaincategory/list', class: '' },
            { id: 'school-statistics ', label: 'Baseline Report', path: '/support/all-school-statistics', class: '' },
            { id: 'business-directory-report', label: 'Business Directory Report', path: '/support/business-directory', class: '' },
            { id: 'program-report', label: 'Program Report', path: '/support/program-report', class: '' },
            { id: 'story-repository', label: 'Story Repository', path: '/support/story-repository', class: '' },
        ],
    };

    const SupportAdmin = {
        id: 'support-admin',
        label: 'Alumni Deep Data',
        children: [
            { id: 'create-new-user', label: 'Create New Student/Alumni', path: '/support/create-new-user', class: '' },
            {
                id: 'non-standard-colleges-report',
                label: 'Free Text College Profiles',
                path: '/support/non-standard-colleges-report',
                class: '',
            },
            { id: 'non-standard-exams-report', label: 'Free Text Exam Profiles', path: '/support/non-standard-exams-report', class: '' },
            // { id: 'domain-data', label: 'Domain Category Report', path: '/domaincategory/list', class: '' },
            { id: 'upload-user', label: 'User Upload', path: '/upload-user', class: '' },
            { id: 'engagement-user', label: 'User Engagement', path: '/management/track/activity-log-report', class: '' },         
            { id: 'upload-outreach', label: 'Outreach Upload', path: '/upload-outreach', class: '' },
            // { id: 'upload-parent', label: 'Parent Upload', path: '/upload-parent', class: '' },           
            { id: 'sync-profile-level', label: 'Profile Level Synchronization Report', path: '/support/sync-profile-level', class: '' },
            { id: 'moengage-reports', label: 'Upload Moengage Data', path: '/moengage_report/upload-file', class: '' },
            { id: 'upload-profile-marker', label: 'Profile Marker Upload', path: '/upload-profile-marker', class: '' }, 
            { id: 'upload-recruiter', label: 'Recruiter Data Upload', path: '/upload-recruiter', class: '' },           
            { id: 'qr-code-checkins-without-profiles', label: 'QR Code Checkins Without Profiles', path: '/support/qr-code-checkins-without-profiles', class: '' },
            // { id: 'free-text-companies', label: 'Free Text Company Profiles', path: '', class: '' },

            // { id: 'benefits-report', label: 'Alumni Benefits Report', path: '/support/benefits-report', class: '' },
            // { id: 'listing', label: 'Institute Contacts', path: '/institute/listing', class: '' },
            // { id: 'Event', label: 'Event Management', path: '/event/manageevent', class: '' },
        ],
    };

    const Events = {
        id: 'school-events',
        label: 'Events',
        children: [
            { id: 'upcoming-events', label: 'Upcoming Events', path: '/events/upcoming', class: '' },
            { id: 'past-events', label: 'Past Events', path: '/events/past', class: '' },
            { id: 'job', label: 'Job & Internship', path: '/job-posting', class: '' },
        ],
    };

    const MeetingAndEvents = {
        id: 'meetings-events',
        label: 'Meetings & Events',
        children: [
            { id: 'upcoming-events', label: 'Upcoming Events', path: '/events/upcoming', class: '' },
            { id: 'past-events', label: 'Past Events', path: '/events/past', class: '' },
        ],
    };

    const Products = {
        id: 'products',
        label: 'Products',
        children: [
            // {
            //     id: 'cagp',
            //     label: 'College Application Guidance Program',
            //     path: 'https://products.univariety.com/product/college-application-guidance-program-gem-go-the-extra-mile-premium/',
            // },
            // {
            //     id: 'mips',
            //     label: 'Masterclass in Public Speaking ',
            //     path: 'https://products.univariety.com/product/masterclass-in-public-speaking/',
            // },
            {
                id: 'pbp',
                label: 'Profile Building program',
                path: 'https://products.univariety.com/product/promap/',
                class: '',
            },
            {
                id: 'cagp',
                label: 'College Application Guidance Program',
                path: 'https://products.univariety.com/product/college-application-guidance-program-gem-go-the-extra-mile-premium/',
                class: '',
            },
            {
                id: 'ps',
                label: 'ProSpeak (Public Speaking)',
                path: 'https://products.univariety.com/product/prospeak/',
                class: '',
            },
            {
                id: 'ict',
                label: 'Ideal Career Test',
                path: '/psychometric_test/careerGuide/Idealcareertest',
                class: '',
            },
            {
                id: 'ptt',
                label: 'Personality Type Test',
                path: '/psychometric_test/careerGuide/PersonalityTest',
                class: '',
            },
            {
                id: 'lst',
                label: 'Learning Style Test',
                path: '/psychometric_test/careerGuide/Learningstyletest',
                class: '',
            },
            {
                id: 'mit',
                label: 'Multiple Intelligence Test',
                path: '/psychometric_test/careerGuide/MultipleIntelligenceTest',
                class: '',
            },
            {
                id: 'sst',
                label: 'Stream Selection Test',
                path: '/psychometric_test/careerGuide/StreamSelectorTest',
                class: '',
            },
            {
                id: 'eat',
                label: 'Engineering Assessment Test',
                path: '/psychometric_test/careerGuide/Engineering',
                class: '',
            },
            {
                id: 'hat',
                label: 'Humanities Assessment Test',
                path: '/psychometric_test/careerGuide/Humanities',
                class: '',
            },
        ].filter((item) => mergedMenu[item.id]),
    };

    const SuperAdminDashboard = {
        id: 'dashboard',
        label: 'DASHBOARD',
        children: [
            // { id: 'dashboard', label: 'Dashboard', path: '/admin/dashboard', class: '' }
            { id: 'all-school-summary', label: 'All Institute Summary', path: '/support/all-school-summary', class: '' },
            // { id: 'alumni-student-matching', label: 'Alumni Match for Students', path: '/support/alumni-student-match', class: '' },
            { id: 'outreach-dashboard', label: 'Outreach Dashboard', path: '/support/outreach-dashboard', class: '' },
            { id: 'vibrancy-dashboard', label: 'Vibrancy Dashboard', path: '/vibrancy-dashboard', class: '' },
            { id: 'user-activity-dashboard', label: 'User Activity Dashboard', path: '/user-activity-dashboard', class: '' },
            
        ],
    };

    const AlumniEngagement = {
        id: 'alumni-engagement',
        label: 'Customer Success',
        children: [
            {
                id: 'hightlightsAndStudentsEngaggement',
                label: 'Teleport',
                path: '/internal/track/alumni-highlights-with-students-engagement',
            },
            {
                id: 'schoolApiKey',
                label: 'School Api Key',
                path: '/schoolApiKey/api-key/',
            },
            { id: 'Student Alumni Matches', label: 'Alumni Match for Students', path: '/support/alumni-student-match', class: '' },
            { id: 'burner-analysis', label: 'Burner Analysis', path: '/support/burner-analysis', class: '' },
            { id: 'placement-analytics', label: 'Placement Analytics', path: '/support/placement-analytics', class: '' },
            {
                id: 'conversationReport',
                label: 'Conversation Report',
                path: '/internal/track/conversation-report',
            },
            {
                id: 'profileMarkerReport',
                label: 'Profile Marker Report',
                path: '/support/profile-marker-report',
            },
            { id: 'custom-report-events', label: 'Event Participation', path: '/support/custom-reports/events', class: '' },
            { id: 'custom-report-rewards', label: 'Rewards & Recognitions', path: '/support/custom-reports/rewards', class: '' },
            { id: 'custom-report-markers', label: 'Ability Markers', path: '/support/custom-reports/markers', class: '' },
            // { id: 'schoolApiKey', label: 'Website API Keys', path: '/schoolApiKey/api-key/', class: '' },
            { id: 'upload-parent', label: 'Parent Upload', path: '/upload-parent', class: '' },
        ],
    };

    const SuperAdminReports = {
        id: 'super-admin-reports',
        label: 'Reports',
        children: [
            {
                id: 'hightlightsAndStudentsEngaggement',
                label: 'Alumni Engagement',
                path: '/internal/track/alumni-highlights-with-students-engagement',
            },
        ],
    };

    const navToggleRef = useRef(null);

    const handleClick = () => {
        // Trigger the click event
        if (windowWidth < 992) {
            // Perform your click event actions here
            navToggleRef.current?.click();
        }
    };

    //  const SchoolManagement = [
    //     Manage,
    //     ManagementTrackStudents,
    //     ManagementTrackAlumni,
    //     ManagementConnect,
    //     ManagementMeetingsAndEvents,
    //     ManagementResources,
    // ];

    let menuConfig;

    const Mentorship = {
        id: 'mentorship',
        label: 'MENTORSHIP',
        children:
            userTypeCode === 'STUDENT'
                ? [
                      {
                          id: 'mentors',
                          label: 'Mentors',
                          path: '/alumni/mentorship/mentee/register',
                          class: '',
                      },
                  ]
                : [
                      { id: 'mentorship-dashboard', label: 'Dashboard', path: '/alumni/mentorship/dashboard', class: '' },
                      { id: 'mentorship-mentees', label: 'My Mentees', path: '/alumni/mentorship/mentees', class: '' },
                  ],
    };

    const showMentorshipMenu = Boolean(mentorshipHeader) && (userTypeCode === 'STUDENT' || userTypeCode === 'ALUMNI');

    let alumniMenu = [MyDashBoard, ...(showMentorshipMenu ? [Mentorship] : []), NextMove, Connect, Contribute, MeetingAndEvents];
    let studentMenu = [MyJourny, ...(showMentorshipMenu && userTypeCode === 'STUDENT' ? [Mentorship] : []), RESEARCH, StudentConnect, Events, Products];
    const loginMode = getLoginMode(); // @UAS-2071

    switch (userTypeCode) {
        case 'ALUMNI':
        case 'STUDENT':
            // switch (pursuingEducationLevelCode) {
            //     case 'K12':
            //         menuConfig = MenuBuilderServiceAlumni.buildStudentMenu(
            //             [MyJourny, RESEARCH, StudentConnect, Events, Products],
            //             sessionState
            //         );
            //         break;
            //     case 'UG':
            //     case 'PG':
            //         menuConfig = MenuBuilderServiceAlumni.buildAlumniMenu(
            //             [MyDashBoard, NextMove, Connect, Contribute, MeetingAndEvents],
            //             sessionState
            //         );
            //         break;
            //     default:
            //         let schoolArr = ['1','2','3','4','5','6','7','8','9','10','11','12'];
            //         if ( schoolArr.includes(pursuingEducationLevelCode) ) {
            //             menuConfig = MenuBuilderServiceAlumni.buildStudentMenu(
            //                 [MyJourny, RESEARCH, StudentConnect, Events, Products],
            //                 sessionState
            //             );
            //             break;
            //         }
            //         throw new Error('Invalid pursuing education level for student');
            // }
            // if ( sessionState.instituteTypeCode == "UNIVERSITY" || (userTypeCode == "ALUMNI" && sessionState.instituteTypeCode == "SCHOOL" ) ) {
            //     menuConfig = MenuBuilderServiceAlumni.buildAlumniMenu(
            //         alumniMenu,
            //         sessionState
            //     );
            // } else {
            //     menuConfig = MenuBuilderServiceAlumni.buildAlumniMenu(
            //         studentMenu,
            //         sessionState
            //     );
            // }
            console.log(sessionState, ' ========= sessionState ======================----------');
            if (sessionState.menuType == 'ALUMNI') {
                menuConfig = MenuBuilderServiceAlumni.buildAlumniMenu(alumniMenu, sessionState);
            } else {
                menuConfig = MenuBuilderServiceAlumni.buildAlumniMenu(studentMenu, sessionState);
            }
            break;

        // menuConfig = MenuBuilderServiceAlumni.buildAlumniMenu(
        //     [MyDashBoard, NextMove, Connect, Contribute, MeetingAndEvents],
        //     sessionState
        // );
        // break;
        // case 'STUDENT':
        //     menuConfig = MenuBuilderServiceAlumni.buildStudentMenu([MyJourny, RESEARCH, StudentConnect, Events, Products], sessionState);
        //     break;
        case 'INSTITUTE_ADMIN':
            menuConfig = [
                Dashboard,
                Manage,
                ManagementConnect,
                ManagementTrack,
                ManagementMeetingsAndEvents, // before this track will come
                ManagementResources,
                // ManagementTrackAlumni,
                // ManagementTrackStudents,
            ];

            if (loginMode === 'LIMITED_ACCESS') {
                const allowedMenus = {
                    "dashboard": ["onboarding"],
                    "manage": [
                        "users", "alumni", "student", "recruiter", "lead",
                        "institute_data", "listing", "qna", "social-integration",
                        "grievance_mgmt", "business-directory-report"
                    ],
                    "management-connect": ["broadcast"],
                    "management-track": ["student-profiles", "careerPreferences", "alumni-profiles", "educationPreferences", "engagementWithStudents", "activityLogReport", "custom-report-events", "custom-report-rewards", "custom-report-markers"],
                }
                menuConfig = menuConfig.filter(menu => {
                    if (allowedMenus[menu.id]) {
                        menu.children = menu.children.filter(child => allowedMenus[menu.id].includes(child.id));
                        return menu.children.length > 0;
                    }
                    return false;
                });
            }
            break;
        // case 'SUPPORT':
        //     menuConfig = [Dashboard, Connect, SupportAdmin];
        //     break;
        case 'SUPER_ADMIN':
            menuConfig = [SuperAdminDashboard, ManageAdmin, AlumniEngagement, ReportsAdmin, SupportAdmin];
            break;
        default:
            if (sessionState.menuType == 'ALUMNI') {
                menuConfig = MenuBuilderServiceAlumni.buildAlumniMenu(alumniMenu, sessionState);
            } else {
                menuConfig = MenuBuilderServiceAlumni.buildAlumniMenu(studentMenu, sessionState);
            }
            break;
    }

    if (!isSchoolAdmin() && sessionStorage.getItem('is-impersonated-session') === 'YES') {
        // menuConfig = [SuperAdminDashboard, AlumniEngagement, SupportAdmin];
        menuConfig = [SuperAdminDashboard, ManageAdmin, AlumniEngagement, ReportsAdmin, SupportAdmin];
    }

    const handleMenuToggle = (menuId) => {
        if (menuId != openMenu) {
            setOpenMenu(menuId);
        } else {
            setOpenMenu('');
        }
    };

    const renderMenuItem = (item) => (
        <li key={item.id} className="nav-item dropdown" data-aos="fade-down">
            <Link
                to="#"
                className="nav-link dropdown-toggle text-white"
                role="button"
                // onClick={!item?.children?.length > 0 ? () => setIsModalOpen(true) : ''} // Open the modal on click
                onClick={!item?.children?.length > 0 ? () => setIsModalOpen(true) : () => handleMenuToggle(item.id)} // Open the modal on click
                // data-bs-toggle="collapse"
                // data-bs-target={`#nav-item-${item.id}`}
                aria-expanded={openMenu ? 'true' : 'false'}
                // aria-expanded="false"
            >
                {item.label}
            </Link>
            {item?.children?.length > 0 && ( // Render only if there are children
                <ul className={`collapse ${openMenu == item.id ? 'show' : ''}`} id={`nav-item-${item.id}`}>
                    {item.children.filter((child) => !child.capability || canCapability(child.capability)).map((child) => (
                        <li key={child.id} data-aos="fade-right">
                            {child.path == '#' ? (
                                <Link
                                    to="#"
                                    className="dropdown-item gray-effect"
                                    onClick={() => setIsModalOpen(true)} // Open the modal on click
                                >
                                    {child.label}
                                </Link>
                            ) : child.path.match(/^http(s)?:\/\//) ? (
                                <a
                                    href={child.path}
                                    className="dropdown-item"
                                    onClick={handleClick}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    {child.label}
                                </a>
                            ) : child.path == '' ? (
                                <div className="menu-label-child">{child.label}</div>
                            ) : (
                                <Link target={child?.target} to={child.path} className="dropdown-item" onClick={handleClick}>
                                    {child.label}
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );

    return (
        <>
            {userTypeCode === 'ALUMNI' ? (
                (userStatusCode === 'ACTIVE' || userStatusCode === 'PROFILE_IN_PROGRESS' || sessionStorage.getItem('is-impersonated-session') === 'YES') && (
                    <nav className="navbar navbar-expand-lg navbar-light custom-nav offcanvas offcanvas-start" id="offcanvasMobile">
                        <button
                            className="mobileonly btn-offcanvas d-none"
                            ref={navToggleRef}
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasMobile"
                            aria-controls="offcanvasMobile">
                            <span className="navbar-toggler-icon">
                                <b>#</b>
                            </span>
                        </button>

                        <ul className="navbar-nav mx-auto d-flex justify-content-around" id="custom-nav">
                            {menuConfig.map((item) => renderMenuItem(item))}
                        </ul>
                    </nav>
                )
            ) : (
                <nav className="navbar navbar-expand-lg navbar-light custom-nav offcanvas offcanvas-start" id="offcanvasMobile">
                    <button
                        className="mobileonly btn-offcanvas d-none"
                        ref={navToggleRef}
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasMobile"
                        aria-controls="offcanvasMobile">
                        <span className="navbar-toggler-icon">
                            <b>#</b>
                        </span>
                    </button>
                    <ul className="navbar-nav mx-auto d-flex justify-content-around" id="custom-nav">
                        {menuConfig.map((item) => renderMenuItem(item))}
                    </ul>
                </nav>
            )}

            {/* Modal component */}
            {isModalOpen && (
                <div className="modal" tabIndex="-1" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    onClick={() => setIsModalOpen(false)}
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    This feature is not a part of your subscription. Please contact your school admin if you need access to
                                    these features.
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    onClick={() => setIsModalOpen(false)}
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default MenuBuilder;
